import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '../../../../../ui_kit/text_area/TextArea';

function TextAreaWrapper(props) {
  const {
    input: {
      value, name, onChange, onFocus, onBlur,
    }, placeholder, label, type, className, icon, hint, meta: { touched, error },
  } = props;
  return (
    <TextArea
      value={value}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      label={label}
      placeholder={placeholder}
      type={type}
      error={touched ? error : null}
      className={className}
      icon={icon}
      hint={hint}
    />
  );
}

TextAreaWrapper.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node,
  hint: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

TextAreaWrapper.defaultProps = {
  className: null,
  icon: null,
  hint: null,
  meta: null,
  label: null,
  placeholder: null,
};

export default TextAreaWrapper;
